module.exports = __webpack_public_path__ + "img/analyse-the-semen.58d8b59b.jpg";